import { Modal, Button } from "@hiya/ui";
import type { User } from "../../types/user";

interface ResetPasswordModalProps {
  user: User | null;
  onClose: () => void;
  onConfirm: () => void;
}

export function ResetPasswordModal({
  user,
  onClose,
  onConfirm,
}: Readonly<ResetPasswordModalProps>) {
  return (
    <Modal open={user !== null} title="Reset Password" onClose={onClose}>
      <p className="text-sm text-text-primary leading-[1.5]">
        Are you sure you want to reset the password for{" "}
        <span className="font-semibold">
          {user?.name} {user?.surname}
        </span>
        ? An email with a temporary password will be sent to{" "}
        <span className="font-semibold">{user?.email}</span>. The doctor will
        be required to set a new password on next login.
      </p>
      <div className="flex gap-2">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Reset Password
        </Button>
      </div>
    </Modal>
  );
}
